import { CookieService } from "ngx-cookie";

export class CookiesGuru {
  constructor(private srv: CookieService) {

  }
  /**
   * @name CookiesGuru#get
   *
   * @description
   * Returns the generic yype value of given cookie key.
   *
   * @param {string} key Id to use for lookup.
   * @returns {T} Deserialized cookie value.
   */
  get<T>(key: string): T {
    return <T>this.srv.getObject(key);
  }
  /**
   * @name CookiesGuru#set
   *
   * @description
   * Serializes and sets a value for given cookie key.
   *
   * @param {string} key Id for the `value`.
   * @param {Object} value Value to be stored.
   */
  set(key: string, object: any): boolean {
    this.srv.putObject(key, object);
    return true;
  }
  /**
   * @name CookiesGuru#remove
   *
   * @description
   * Remove given cookie.
   *
   * @param {string} key Id of the key-value pair to delete.
   * @param {CookieOptions} options (Optional) Options object.
   */
  remove(key: string): boolean {
    this.srv.remove(key);
    return true;
  }
  /**
   * @name CookieService#removeAll
   *
   * @description
   * Remove all cookies.
   */
  removeAll(): boolean {
    this.srv.removeAll();
    return true;
  }

}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/helper/cookies.guru.ts